import { render, staticRenderFns } from "./TechnologyIlluminate.vue?vue&type=template&id=3fac55c0&scoped=true"
import script from "./TechnologyIlluminate.vue?vue&type=script&lang=js"
export * from "./TechnologyIlluminate.vue?vue&type=script&lang=js"
import style0 from "./TechnologyIlluminate.vue?vue&type=style&index=0&id=3fac55c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fac55c0",
  null
  
)

export default component.exports